"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = asError;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asError(action) {
  if (_typeof(action) === 'object' && action !== null) {
    action.error = true;
  }

  return action;
}

;


//////////////////
// WEBPACK FOOTER
// ./~/redux-act/lib/asError.js
// module id = 2024
// module chunks = 0